import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #CACACA;
  height: 260px;
  width: 100%;
  border-radius: 6px;

${props => !props.active && css`
  border: 1px solid #CACACA;
  background-color: #f3f3f3;
`}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #CACACA;
  padding: 12px;
`;

export const GroupName = styled.h2`
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 500;
  margin: 0;
  color: #000;
`;

export const BusinessUnitColor = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 6px;
  background-color: ${props => props.color};
  margin-right: 8px;
`;

export const SettingsContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-end;
  justify-content: flex-end;
`;

export const SettingsButton = styled(Link)`
  cursor: pointer;
  display: flex;
  flex: 1;
  max-width: 24px;
  max-height: 24px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  border: 0px;
  background: transparent;
  color: #000;
`;

export const PackageCommitteesContainer = styled.div`
  display: flex;
  overflow: auto;
  flex-direction: column;
  flex: 1;
`;

export const PackageCommitteeItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #CACACA;
`;

export const PackageCommitteeHeader = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  cursor: pointer;
`;

export const PackageDragButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;

  svg {
    color: #DBDBDB;
    width: 18px;
    height: 18px;
    margin-bottom: 4px;
  }
`;

export const PackageCommitteeName = styled(Link)`
  font-family: 'Roboto', sans-serif;
  color: #4E65F4;
  font-size: 16px;
  cursor: pointer;
  ${props => !props.active && css`
    color: #6c739b;
  `}
`;

export const ExpandContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

export const ExpandButton = styled.button`
  cursor: pointer;
  display: flex;

  background-color: transparent;
  align-items: center;
  justify-content: center;
  border: none;
`;

export const DropDownSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 12px;
  padding-left: 6px;
`;

export const CommittesSection = styled.div`

`;

export const GroupsSection = styled.div`
  margin-top: 6px;
`;

export const GroupsList = styled.ul`
  margin: 0px;
`;

export const GroupItem = styled.li`
  font-family: 'Roboto', sans-serif;
  color: #4E65F4;
  font-size: 16px;
  cursor: pointer;
  ${props => !props.active && css`
    color: #6c739b;
  `}
`;

export const SubItemTitle = styled.h3`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  color: #000;
  margin-bottom: 2px;
`;

export const CommitteesList = styled.span`
  font-family: 'Roboto', sans-serif;
  color: #4E65F4;
  font-size: 16px;
  cursor: pointer;
  margin-left: 8px;
`;

